// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {sync} from 'vuex-router-sync'
import { BPagination, BProgress, BTable, BTooltip } from 'bootstrap-vue/dist/bootstrap-vue.esm.min'
import ToggleButton from 'vue-js-toggle-button'
import App from './App'
import ErrorAlert from './components/Common/ErrorAlert'
import router from './router'
import store from './store'
import { initRecaptcha } from './services/recaptcha'
import { initClarity } from './services/clarity'

Vue.use(ToggleButton)

Vue.component('b-tooltip', BTooltip)
Vue.component('b-pagination', BPagination)
Vue.component('b-progress', BProgress)
Vue.component('b-table', BTable)

// TEL-2243: registrado globalmente porque aparece em ~30 telas. Evita repetir
// import e `components: {}` em cada uma, seguindo o mesmo padrao usado acima
// para os componentes do bootstrap-vue.
Vue.component('ErrorAlert', ErrorAlert)

sync(store, router)

Vue.config.productionTip = false

initRecaptcha()

if (store.state.auth.user) {
  initClarity(store.state.auth.user.email)
}

// Disable warning about using .native on <a> tags
Vue.config.warnHandler = function (msg) {
  if (msg !== 'The .native modifier for v-on is only valid on components but it was used on <a>.') {
    console.error(msg)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js